module.exports = __webpack_public_path__ + "img/settings_icon.0aa73cb4.svg";